import type { Reducer } from 'redux';
import { combineReducers } from 'redux';

import adalReducer from './adal/reducer';
import applicationConfigReducer from './applicationConfig/reducer';
import bootstrapReducer from './bootstrap/reducer';
import featureRolloutReducer from './featureRollout/reducer';
import hostsReducer from './hosts/reducer';
import legacyYammerReducer from './legacyYammer/reducer';
import localeReducer from './locale/reducer';
import loggingReducer from './logging/reducer';
import lokiReducer from './loki/reducer';
import msGraphReducer from './msGraph/reducer';
import msalReducer from './msal/reducer';
import networkReducer from './network/reducer';
import networkContextReducer from './networkContext/reducer';
import networkExternalSettingsReducer from './networkExternalSettings/reducer';
import networkLogoReducer from './networkLogo/reducer';
import networkPublisherSettingsReducer from './networkPublisherSettings/reducer';
import networkReportMessageSettingsReducer from './networkReportMessageSettings/reducer';
import networkTopicSettingsReducer from './networkTopicSettings/reducer';
import networkUsagePolicyReducer from './networkUsagePolicy/reducer';
import ocvReducer from './ocv/reducer';
import sharedConfigReducer from './sharedConfig/reducer';
import substrateReducer from './substrate/reducer';
import tenorReducer from './tenor/reducer';
import type { Session } from './types';
import userReducer from './user/reducer';

const reducer: Reducer<Session> = combineReducers<Session>({
  adal: adalReducer,
  application: applicationConfigReducer,
  bootstrap: bootstrapReducer,
  featureRollout: featureRolloutReducer,
  hosts: hostsReducer,
  locale: localeReducer,
  logging: loggingReducer,
  loki: lokiReducer,
  msal: msalReducer,
  msGraph: msGraphReducer,
  network: networkReducer,
  networkContext: networkContextReducer,
  networkLogo: networkLogoReducer,
  networkExternalSettings: networkExternalSettingsReducer,
  networkPublisherSettings: networkPublisherSettingsReducer,
  networkUsagePolicy: networkUsagePolicyReducer,
  networkReportMessageSettings: networkReportMessageSettingsReducer,
  networkTopicSettings: networkTopicSettingsReducer,
  ocv: ocvReducer,
  shared: sharedConfigReducer,
  substrate: substrateReducer,
  tenor: tenorReducer,
  user: userReducer,
  legacyYammer: legacyYammerReducer,
});

export default reducer;
